











import Vue from 'vue';
import {Component, Inject} from 'vue-property-decorator';

@Component
export default class TabsHead extends Vue {
  @Inject() eventBus!: Vue;

  mounted() {
    this.eventBus.$on('update:headChange', (el: HTMLElement) => {
      const index = [...el.parentNode!.querySelectorAll('.tabs-item')].indexOf(el);
      Object.assign((this.$refs.line as HTMLElement).style, {
        width: el.offsetWidth + 'px',
        left: index * el.offsetWidth + 'px',
        top: el.offsetHeight - 1 + 'px'
      });
    });
  }
}
